import { lazy } from 'react'
import { Navigate, Route, Routes as RouterRoutes, useLocation } from 'react-router-dom'

import { paths } from './paths'
import { isFeatureEnabled } from './config'

const DeleteAccountErrorPage = lazy(() =>
  import('./delete-account/DeleteAccountErrorPage').then((module) => ({ default: module.DeleteAccountErrorPage }))
)
const DeleteAccountExpiredPage = lazy(() =>
  import('./delete-account/DeleteAccountExpiredPage').then((module) => ({ default: module.DeleteAccountExpiredPage }))
)
const DeleteAccountSuccessPage = lazy(() =>
  import('./delete-account/DeleteAccountSuccessPage').then((module) => ({ default: module.DeleteAccountSuccessPage }))
)
const LogoutPage = lazy(() => import('./logout/LogoutPage').then((module) => ({ default: module.LogoutPage })))
const PasswordResetPage = lazy(() =>
  import('./password-reset/PasswordResetPage').then((module) => ({ default: module.PasswordResetPage }))
)
const RecoveryPage = lazy(() => import('./recovery/RecoveryPage').then((module) => ({ default: module.RecoveryPage })))
const SignInPage = lazy(() => import('./sign-in/SignInPage').then((module) => ({ default: module.SignInPage })))
const SignUpPage = lazy(() => import('./sign-up/SignUpPage').then((module) => ({ default: module.SignUpPage })))
const SignupExpiredPage = lazy(() =>
  import('./sign-up/SignupExpiredPage').then((module) => ({ default: module.SignupExpiredPage }))
)
const VerifyAccountErrorPage = lazy(() =>
  import('./verify-account/VerifyAccountErrorPage').then((module) => ({ default: module.VerifyAccountErrorPage }))
)
const VerifyAccountExpiredPage = lazy(() =>
  import('./verify-account/VerifyAccountExpiredPage').then((module) => ({ default: module.VerifyAccountExpiredPage }))
)
const VerifyAccountPage = lazy(() =>
  import('./verify-account/VerifyAccountPage').then((module) => ({ default: module.VerifyAccountPage }))
)
const WelcomePage = lazy(() => import('./welcome/WelcomePage').then((module) => ({ default: module.WelcomePage })))

export const Routes = () => {
  const { search } = useLocation()

  return (
    <RouterRoutes>
      <Route path={paths.LOGOUT} element={<LogoutPage />} />
      <Route path={paths.RECOVERY} element={<RecoveryPage />} />
      <Route path={paths.WELCOME} element={<WelcomePage />} />
      <Route path={`${paths.PASSWORD_RESET}/:token`} element={<PasswordResetPage />} />
      <Route path={paths.SIGN_IN} element={<SignInPage />} />
      <Route path={`${paths.SIGN_UP}/${paths.EXPIRED}`} element={<SignupExpiredPage />} />
      {isFeatureEnabled('signUp') && (
        <>
          <Route path={paths.SIGN_UP} element={<SignUpPage />} />
          <Route path={`${paths.SIGN_UP}/${paths.SUCCESS}`} element={<SignUpPage />} />
        </>
      )}
      <Route path={`${paths.DELETE}/${paths.SUCCESS}`} element={<DeleteAccountSuccessPage />} />
      <Route path={`${paths.DELETE}/${paths.EXPIRED}`} element={<DeleteAccountExpiredPage />} />
      <Route path={`${paths.DELETE}/${paths.ERROR}`} element={<DeleteAccountErrorPage />} />
      <Route path={paths.VERIFY} element={<VerifyAccountPage />} />
      <Route path={`${paths.VERIFY}/${paths.EXPIRED}`} element={<VerifyAccountExpiredPage />} />
      <Route path={`${paths.VERIFY}/${paths.ERROR}`} element={<VerifyAccountErrorPage />} />
      <Route index element={<Navigate to={{ pathname: `/${paths.SIGN_IN}`, search }} />} />
      <Route path="*" element={<Navigate to={{ pathname: `/${paths.SIGN_IN}`, search }} />} />
    </RouterRoutes>
  )
}
